import PersonalPage from "./personal-page";

export default PersonalPage;